import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import Clearfix from 'components/Clearfix/Clearfix';

import { twitterColor,facebookBoxShadow,instagramColor } from 'assets/jss/material-kit-pro-react';



const useStyles = makeStyles((theme) => ({

  root: {
    //display: 'flex',
    //flexWrap: 'wrap',
    minWidth: 80,
    maxWidth: 80,
    width: '100%',
    margin: '10px auto',
  },
  image: {
    borderRadius: "6px !important",
    position: 'relative',
    backgroundColor : instagramColor,
    height: 80,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 80,
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.3,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        //border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    borderRadius: "6px !important",
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    ...facebookBoxShadow
  },
  imageSrc: {
    borderRadius: "6px !important",
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    borderRadius: "6px !important",
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: twitterColor,
    opacity: 0,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    //backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  
}));

export default function ButtonBases(props) {
  const classes = useStyles();

  function handleClick(e){
    
    props.onClick(props.id)
  }

  return (
    <div className={classes.root}>
        <ButtonBase
          focusRipple
          key={props.title}
          id={props.id}
          name={props.title}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width: props.width,
          }}
          onClick={handleClick}
        >
          <span
            className={classes.imageSrc}
            style={{
              backgroundImage: `url(${props.image})`,
            }}
          />
          <span className={classes.imageBackdrop} />
          <span className={classes.imageButton}>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.imageTitle}
            >
              {/*props.title*/}
              <span className={classes.imageMarked} />
            </Typography>
          </span>
        </ButtonBase>
        <Clearfix />
          <div>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.textTitle}
            >
              {props.title}
            </Typography>
        </div>
    </div>
  );
}